import {
  Footer,
  GiftCardMessageWrapper,
  GiftCardSectionWrapper,
  GuaranteeIcons,
  Hr,
  ImageBlock,
  InfoLinks,
  MainBlock,
  MainContainer,
  MobileAccordionChevron,
  MobileAccordionContent,
  MobileAccordionItem,
  MobileAccordionRoot,
  MobileAccordionTrigger,
  ProductInfoBlock,
  ProductSections,
  ProductSectionsContainer,
  Separator,
  Sliders,
  StyledDetailsCard,
  StyledShopTheLookButton,
} from './ProductPage.styles'

const ProductPage = {
  MobileAccordionChevron,
  MobileAccordionContent,
  MobileAccordionItem,
  MobileAccordionRoot,
  MobileAccordionTrigger,
  Footer,
  GiftCardMessageWrapper,
  GiftCardSectionWrapper,
  GuaranteeIcons,
  Hr,
  ImageBlock,
  InfoLinks,
  MainBlock,
  MainContainer,
  ProductInfoBlock,
  ProductSections,
  ProductSectionsContainer,
  Separator,
  Sliders,
  StyledDetailsCard,
  StyledShopTheLookButton,
}

export { ProductPage }
